import { bearerFetcher, useAuthBearerFetch } from "matsuri-hooks"
import { useAuth } from "m2m-components/storage/useM2mAuth"
import { Operation } from "./../model/operation"
import { m2mCleaning_cleanerV3 } from "./../endpoints/m2m-cleaning.cleaner-v3"

export const requestStartOperation = (token: string, cleaningId: string) => {
    return bearerFetcher(
        token,
        m2mCleaning_cleanerV3.startOperation({ operationId: cleaningId }),
        {
            method: "POST"
        }
    )
}

export const requestFinishOperation = (token: string, cleaningId: string) => {
    return bearerFetcher(
        token,
        m2mCleaning_cleanerV3.finishOperation({ operationId: cleaningId }),
        {
            method: "POST"
        }
    )
}

export const requestReportOperation = (
    token: string,
    cleaningId: string,
    body?: { quality_status?: string; placementIncomplete?: boolean }
) => {
    return bearerFetcher(
        token,
        m2mCleaning_cleanerV3.reportOperations({ operationId: cleaningId }),
        {
            method: "POST",
            ...(body && { body: JSON.stringify(body) })
        }
    )
}

export const useOperation = (token: string, cleaningId: string | undefined) => {
    return useAuthBearerFetch<Operation>(
        token,
        cleaningId
            ? m2mCleaning_cleanerV3.findById({ operationId: cleaningId })
            : null,
        {}
    )
}

export const useOperations = (cleaningIds: string[] | null) => {
    const { token } = useAuth()
    const endpoint = m2mCleaning_cleanerV3.findOperationsByIds

    return useAuthBearerFetch<Operation[]>(
        token,
        cleaningIds ? endpoint() : null,
        {
            method: endpoint.method,
            body: JSON.stringify({ ids: cleaningIds })
        }
    )
}

export const requestCreateTrouble = (
    token: string,
    cleaningId: string,
    trouble: {
        description: string
        pictures: string[]
    }
) => {
    return bearerFetcher(
        token,
        m2mCleaning_cleanerV3.createTrouble({ operationId: cleaningId }),
        {
            method: "POST",
            body: JSON.stringify(trouble)
        }
    )
}
